'use client';

import { clsx } from 'clsx';
import { FC } from 'react';
import { BannerTrustStoryblok } from 'storyblok-types';
import { Button } from 'atoms/Button';
import { Image } from 'atoms/Image/Image';
import { renderLink } from 'atoms/StoryBlokLink';
import { P } from 'atoms/Typography';
import { useRouter } from 'modules/next/hooks';
import styles from './styles.module.css';
import themeStyles from 'styles/theme/theme.module.css';

export const StoryblokBannerTrust: FC<{ blok: BannerTrustStoryblok }> = ({
  blok,
}) => {
  const { push } = useRouter();
  const link = blok?.link?.[0];
  const theme = blok?.theme?.[0]?.value || 'theme-blue-moon-shining';
  const url = link && renderLink(link.parameters);
  const Tag = url ? 'a' : 'div';
  const subtitleColor = blok?.subtitles_color?.color || '#fff';

  /** fix hydration error <a> in <a> */
  const handleClick = () => url && push(url);

  return (
    <Tag
      href={url || ''}
      className={clsx(styles.block, themeStyles[`theme-${theme}`])}
    >
      <Image
        className={styles.image}
        src={blok.image?.filename}
        alt={blok?.image?.alt}
      />
      <div className={styles.content}>
        <P className={styles.title}>{blok.title}</P>
        <div className={styles.subTitle}>
          <P className={styles.subTitle_1} style={{ color: subtitleColor }}>
            {blok.subTitle_1}
          </P>
          <P className={styles.subTitle_2} style={{ color: subtitleColor }}>
            {blok.subTitle_2}
          </P>
        </div>
        {url && link?.text && (
          <Button className={styles.button} onClick={handleClick}>
            {link?.text}
          </Button>
        )}
      </div>
    </Tag>
  );
};
